import { render, staticRenderFns } from "./growthValueDetailDialog.vue?vue&type=template&id=5c5f0844"
import script from "./growthValueDetailDialog.vue?vue&type=script&lang=js"
export * from "./growthValueDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./growthValueDetailDialog.vue?vue&type=style&index=0&id=5c5f0844&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports